export default __webpack_public_path__ + "static/undraw_fixing_bugs-15851efc25c7f37b252e067e1a8ab0ee.svg";